import { all, put, takeLatest, takeEvery, select } from 'redux-saga/effects';
import { VISIBLE } from 'src/constants/appConstants';
import {
    getUsageDetailsFunc,
    getPricesForItemsFunc,
    getDropdownOptionsFunc,
    validateMazorCodeFunc,
    getProcedureInfoFunc,
    validateProductDetailsFunc,
    validateUnidPlanFeeItemsFunc,
    validateReplenProductsFunc,
    usageAttachmentUploadFunc,
    createUsageOrderFunc,
    updateUsageOrderFunc,
    deleteAttachmentFunc,
    getImagePoPreviewFunc,
    cancelUsageOrderFunc,
    getDisparencyFunc,
    discrepancyAttachmentUploadFunc,
    discrepancyDeleteAttachmentFunc,
    discrepancyUpdateDataFunc,
    getOrderStatusDetailsFunc,
    getAccountMessageValidationFunc,
    validateRelenFunc,
} from './dataServices';
import {
    GET_USAGE_DETAILS,
    GET_USAGE_DETAILS_SUCCESS,
    GET_USAGE_DETAILS_FAILURE,
    GET_USAGE_DETAILS_DISCREPENCY_SUCCESS,
    GET_USAGE_DETAILS_DISCREPENCY_FAILURE,
    CREATE_USAGE_ORDER,
    CREATE_USAGE_ORDER_SUCCESS,
    UPDATE_USAGE_ORDER,
    UPDATE_USAGE_ORDER_SUCCESS,
    GET_PRICES_FOR_ITEMS,
    GET_PRICES_FOR_ITEMS_SUCCESS,
    GET_PRICES_FOR_ITEMS_FAILURE,
    GET_DROPDOWN_OPTIONS,
    GET_DROPDOWN_OPTIONS_SUCCESS,
    GET_DROPDOWN_OPTIONS_FAILURE,
    VALIDATE_MAZOR_CODE,
    VALIDATE_MAZOR_CODE_RESPONSE,
    GET_PROCEDURE_INFO,
    GET_PROCEDURE_INFO_SUCCESS,
    GET_PROCEDURE_INFO_FAILURE,
    VALIDATE_REPLEN_PRODUCTS,
    VALIDATE_REPLEN_PRODUCTS_RESPONSE,
    VALIDATE_PRODUCT_DETAILS,
    VALIDATE_PRODUCT_DETAILS_SUCCESS,
    VALIDATE_PRODUCT_DETAILS_FAILURE,
    VALIDATE_UNID_PLAN_FEE_ITEMS,
    VALIDATE_UNID_PLAN_FEE_ITEMS_SUCCESS,
    VALIDATE_UNID_PLAN_FEE_ITEMS_FAILURE,
    USAGE_ATTACHMENT_UPLOAD,
    USAGE_ATTACHMENT_UPLOAD_FAILURE,
    DELETE_ATTACHMENT_REQUEST,
    DELETE_ATTACHMENT_REQUEST_SUCCESS,
    DELETE_ATTACHMENT_REQUEST_FAILURE,
    GET_IMAGE_PO_PREVIEW,
    GET_IMAGE_PO_PREVIEW_FAILURE,
    GET_IMAGE_PO_PREVIEW_SUCCESS,
    CANCEL_USAGE_ORDER,
    CANCEL_USAGE_ORDER_COMPLETION,
    SET_SHOW_CONTACT_LOGISTICS_POPUP,
    GET_SHIPPING_METHODS_REPORT_USAGE,
    GET_SHIP_TO_ADDRESS_REPORT_USAGE,
    GET_DISCREPANCY_DATA,
    GET_DISCREPANCY_DATA_SUCCESS,
    GET_DISCREPANCY_DATA_FAILURE,
    USAGE_DISCREPANCY_ATTACHMENT_UPLOAD,
    USAGE_DISCREPANCY_ATTACHMENT_UPLOAD_SUCCESS,
    USAGE_DISCREPANCY_ATTACHMENT_UPLOAD_FAILURE,
    DELETE_DISCREPANCY_ATTACHMENT_REQUEST,
    DELETE_DISCREPANCY_ATTACHMENT_REQUEST_SUCCESS,
    DELETE_DISCREPANCY_ATTACHMENT_REQUEST_FAILURE,
    PUT_DISCREPANCY_DATA_REQUEST,
    PUT_DISCREPANCY_DATA_REQUEST_SUCCESS,
    PUT_DISCREPANCY_DATA_REQUEST_FAILURE,
    GET_ORDER_STATUS_DETAILS_SUCCESS,
    GET_ORDER_STATUS_DETAILS_FAILURE,
    GET_ORDER_STATUS_DETAILS,
    VALIDATE_ACCOUNT_FAILURE,
    VALIDATE_ACCOUNT_SUCCESS,
    VALIDATE_REPORT_ACCOUNT,
    GET_TRANSFER_RECIPIENT_METHODS,
    GET_BARCODE_ITEMS,
    VALIDATE_REPLEN,
    VALIDATE_REPLEN_SUCCESS,
    VALIDATE_REPLEN_FAILURE,
} from '../action/types';
import {
    getModifiedProcedureResponse,
    getValidatedItemTableData,
    getReplenNonTissueItems,
} from 'src/pages/reportUsage/utils/dataModificaionUtil';
import {
    convertObjectToQueryParams,
    setCurrencyFormat,
    updateCurrencyCode,
    procedureFilterData,
    logUiErrorToBackend,
} from 'src/utils/util';
import {
    setPONonTissueImageDetails,
    setPOTissueImageDetails,
    validateReplenProducts,
    getDropdownOptionsRequest,
    setPageLoader,
} from 'src/pages/reportUsage/redux/action/actionCreators';
import { checkIfValidProductsInRecordScreen } from 'src/pages/reportUsage/utils/eventHandlerUtil';
import shipToAddressSaga from './shipToAddressSaga';
import shippingMethodSaga from './shippingMethodsSaga';
import { resetDescrepancyDetails } from '../action/actionCreators';
import getTransferRecipient from './usageTransferRecipientSaga';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { WithinTerritory } from '../../replen/components/replenConstant';

/*
  Worker Saga: Fired on GET_USAGE_DETAILS_REQUEST action
*/

const validateResponse = (response) => {
    if (Array.isArray(response)) {
        const firstResponse = response[0];
        if (
            firstResponse.statusCode === '11000' ||
            firstResponse.statusCode === '11001'
        )
            return true;
    }
    if (response.statusCode === '10501') {
        return false;
    }
};

function* fetchUsageDetailsSaga(action) {
    const usageObj = action.payload;
    const isDiscrepencyCheck = usageObj.isDiscrepencyCheck;
    delete usageObj.isDiscrepencyCheck;
    const response = yield getUsageDetailsFunc(
        convertObjectToQueryParams(usageObj)
    );
    if (response !== 'error') {
        if (isDiscrepencyCheck) {
            yield put({
                type: GET_USAGE_DETAILS_DISCREPENCY_SUCCESS,
                payload: {
                    ...response.usageDetails,
                },
            });
        } else {
            yield put({
                type: GET_USAGE_DETAILS_SUCCESS,
                payload: response.usageDetails,
            });
        }
    } else {
        yield put(setPageLoader(false)); // Stop loading
        if (isDiscrepencyCheck) {
            yield put({
                type: GET_USAGE_DETAILS_DISCREPENCY_FAILURE,
                payload: { status: 'failed' },
            });
        } else {
            yield put({
                type: GET_USAGE_DETAILS_FAILURE,
                payload: { status: 'failed' },
            });
        }
    }
}

function* createUsageOrderSaga(action) {
    const response = yield createUsageOrderFunc(action.payload.reportUsageObj);
    yield put({
        type: CREATE_USAGE_ORDER_SUCCESS,
        payload: { ...response, clickedBtn: action.payload.clickedBtn },
    });
}

function* updateUsageOrderSaga(action) {
    const response = yield updateUsageOrderFunc(action.payload.reportUsageObj);
    yield put({
        type: UPDATE_USAGE_ORDER_SUCCESS,
        payload: { ...response, clickedBtn: action.payload.clickedBtn },
    });
}

function* getPricesForItemsSaga(action) {
    const response = yield getPricesForItemsFunc(
        convertObjectToQueryParams(action.payload)
    );
    if (response !== 'error') {
        const priceCurrencyISOCode =
            response.priceDetails && response.priceDetails[0]?.currencyISOCode;
        localStorage.setItem('currencyISOCode', priceCurrencyISOCode);
        updateCurrencyCode(priceCurrencyISOCode);
        yield put({
            type: GET_PRICES_FOR_ITEMS_SUCCESS,
            payload: {
                items: response.priceDetails
                    ? response.priceDetails.map((item) => {
                          if (item.basePrice) {
                              item.basePrice = setCurrencyFormat(
                                  item.basePrice
                              );
                          }
                          //   else {
                          //       item.basePrice = setCurrencyFormat(500);
                          //   }
                          return item;
                      })
                    : [],
            },
        });
        yield put({
            type: 'SET_ITEMS_PRICING_DONE_FLAG',
            payload:
                response.priceDetails?.length > 0 &&
                response.priceDetails.every((pItem) =>
                    Object.prototype.hasOwnProperty.call(pItem, 'basePrice')
                ),
        });
    } else {
        yield put({
            type: GET_PRICES_FOR_ITEMS_FAILURE,
            payload: {
                items: [
                    {
                        // basePrice: '$800.00',
                        // currencyISOCode: 'USD',
                        // description: 'CONNECTOR 5454120 4.75-5.5 CLSD LAT 20',
                        // isLot: false,
                        // isSerialRequired: false,
                        // isSet: false,
                        // listPrice: '1300.0',
                        // materialType: 'ZUFG',
                        // productCFN: '000505INT',
                        // salesOrg: 'S024',
                        // uom: 'EA',
                    },
                ],
                status: 'failed',
            },
        });
        yield put({ type: 'SET_ITEMS_PRICING_DONE_FLAG', payload: false });
    }
}

//dummy data,

function* getDropdownOptionsSaga(action) {
    const {
        accountPhysicianAPIUsage,
        accountPhysicianAPIReplenishment,
        physicianDropdownZGReportUsageReplenishmentVisibility,
        physicianDropdownZGReportUsageVisibility,
        salesOrg,
        countryISOCode,
    } = yield select((state) => ({
        accountPhysicianAPIUsage: state.loginReducer.accountPhysicianAPIUsage,
        accountPhysicianAPIReplenishment:
            state.loginReducer.accountPhysicianAPIReplenishment,
        physicianDropdownZGReportUsageReplenishmentVisibility: state.loginReducer.physicianDropdownZGReportUsageReplenishmentVisibility,
        physicianDropdownZGReportUsageVisibility: state.loginReducer.physicianDropdownZGReportUsageVisibility,
        salesOrg: state.loginReducer.salesOrg,
        countryISOCode: state.loginReducer.hybrisUserDetails.countryISOCode,
    }));
    const response = yield getDropdownOptionsFunc(
        action.payload,
        accountPhysicianAPIReplenishment,
        accountPhysicianAPIUsage,
        physicianDropdownZGReportUsageReplenishmentVisibility,
        physicianDropdownZGReportUsageVisibility,
    );

    if (response !== 'error') {
        yield put({
            type: GET_DROPDOWN_OPTIONS_SUCCESS,
            payload: {
                dropdownName: action.payload.dropdownType,
                dropdownOptions: response,
            },
        });
    } else {
        yield put({
            type: GET_DROPDOWN_OPTIONS_FAILURE,
            payload: {
                dropdownName: action.payload.dropdownType,
                dropdownOptions: [],
            },
        });
    }
}

function* validateMazorCodeSaga(action) {
    const response = yield validateMazorCodeFunc(action.payload.reqBody);
    yield put({
        type: VALIDATE_MAZOR_CODE_RESPONSE,
        payload: {
            ...response,
            mazorXvalidationClickedBtn:
                action.payload.mazorXvalidationClickedBtn,
        },
    });
}

function* getProcedureInfoSaga(payload) {
    const {
        additionalProcedure,
        physicianFinderEligibility,
        retractorUsed,
        biologicsDetail,
        advancedEnergy,
        levelsUsed,
        procedurePageVisibility,
        biologicsUsed,
        deformityCorrection,
        additionalProcedureEquity,
        physicianFinderEligibilityEquity,
        retractorUsedEquity,
        biologicsDetailEquity,
        advancedEnergyEquity,
        levelsUsedEquity,
        biologicsUsedEquity,
        deformityCorrectionEquity,
    } = yield select((state) => ({
        additionalProcedure: state.loginReducer.additionalProcedure,
        advancedEnergy: state.loginReducer.advancedEnergy,
        procedurePageVisibility: state.loginReducer.procedurePageVisibility,
        deformityCorrection: state.loginReducer.deformityCorrection,
        biologicsUsed: state.loginReducer.biologicsUsed,
        levelsUsed: state.loginReducer.levelsUsed,
        biologicsDetail: state.loginReducer.biologicsDetail,
        physicianFinderEligibility:
            state.loginReducer.physicianFinderEligibility,
        retractorUsed: state.loginReducer.retractorUsed,
        additionalProcedureEquity: state.loginReducer.additionalProcedureEquity,
        advancedEnergyEquity: state.loginReducer.advancedEnergyEquity,
        deformityCorrectionEquity: state.loginReducer.deformityCorrectionEquity,
        biologicsUsedEquity: state.loginReducer.biologicsUsedEquity,
        levelsUsedEquity: state.loginReducer.levelsUsedEquity,
        biologicsDetailEquity: state.loginReducer.biologicsDetailEquity,
        physicianFinderEligibilityEquity:
            state.loginReducer.physicianFinderEligibilityEquity,
        retractorUsedEquity: state.loginReducer.retractorUsedEquity,
        countryISOCode: state.loginReducer.hybrisUserDetails.countryISOCode,
        procedureList:
            state.reportUsageRootReducer?.dropdownData?.procedures
                ?.procedureList,
    }));

    
    const response = yield getProcedureInfoFunc(payload?.payload?.data);
    if (response !== 'error') {
        let obj = {};
        const isFrom = payload?.payload?.isFrom;
        let data;
        const modifiedResponse =
            response && getModifiedProcedureResponse(response);
        if (isFrom === 'Usage' || isFrom === 'Equity') {
            obj = modifiedResponse;

            const isEquity = isFrom === 'Equity';

            const config = {
                additionalProcedure: isEquity
                    ? additionalProcedureEquity
                    : additionalProcedure,
                deformityCorrection: isEquity
                    ? deformityCorrectionEquity
                    : deformityCorrection,
                biologicsUsed: isEquity ? biologicsUsedEquity : biologicsUsed,
                levelsUsed: isEquity ? levelsUsedEquity : levelsUsed,
                physicianFinderEligibility: isEquity
                    ? physicianFinderEligibilityEquity
                    : physicianFinderEligibility,
                biologicsDetail: isEquity
                    ? biologicsDetailEquity
                    : biologicsDetail,
                retractorUsed: isEquity ? retractorUsedEquity : retractorUsed,
                advancedEnergy: isEquity
                    ? advancedEnergyEquity
                    : advancedEnergy,
            };

            const isConfigApplicable = (field) =>
                field &&
                field.ruleValue &&
                (isEquity || procedurePageVisibility);

            const checkMetadata = (field, expected) => {
                const meta = field?.metadata?.[0];
                return (
                    meta === expected ||
                    meta?.toLowerCase() === expected?.toLowerCase()
                );
            };
            const isAdvancedEnergyNotPresent = (firstMeta = [], secondMeta = []) => {
                const firstHasAdvancedEnergy = firstMeta.some(
                  item => item.toLowerCase() === 'advanced energy'
                );
              
                if (firstHasAdvancedEnergy) {
                  return true;
                }
              
                const secondHasProcedureData = secondMeta.some(
                  item => item.toLowerCase() === 'procedure_data'
                );
              
                // If first doesn't have Advanced Energy, return false if second doesn't have Procedure_data
                return secondHasProcedureData;
              };
              
                
           
 const advancedEnergyMetadata =
                    config.advancedEnergy?.metadata?.[0];
            if (isConfigApplicable(config.additionalProcedure)||advancedEnergyMetadata.length>0) {
                const metadata = config.additionalProcedure?.metadata?.[0];
               

                data = procedureFilterData(
                    modifiedResponse.additionalProcedure,
                    config.additionalProcedure,
                    checkMetadata(
                        config.additionalProcedure,
                        'ADDITIONAL_PROCEDURE_DATA'
                    )
                        ? config.additionalProcedure.ruleValue === VISIBLE
                            ? 'Procedure_Data_Enabled'
                            : 'ADDITIONAL_PROCEDURE_DATA'
                        : checkMetadata(
                              config.additionalProcedure,
                              'Procedure_data'
                          )
                        ? 'Procedure_Data_Enabled'
                        : false,

                    config.advancedEnergy?.metadata?.length === 0 ||
                        isAdvancedEnergyNotPresent(
                            config.additionalProcedure?.metadata,
                            config.advancedEnergy?.metadata
                        )
                        ? isAdvancedEnergyNotPresent(
                              config.additionalProcedure?.metadata,
                              config.advancedEnergy?.metadata
                          ) || config.advancedEnergy?.ruleValue === VISIBLE
                            ? 'Procedure_Data_Enabled'
                            : false
                        : checkMetadata(config.advancedEnergy, 'Procedure_data')
                        ? 'Procedure_Data_Enabled'
                        : config.advancedEnergy
                );
                obj = data?{ ...obj, additionalProcedure: data }:obj;
            }

            if (isConfigApplicable(config.deformityCorrection)) {
                data = procedureFilterData(
                    modifiedResponse.technologies,
                    config.deformityCorrection,
                    checkMetadata(
                        config.deformityCorrection,
                        'DEFORMITY_CORRECTION'
                    )
                        ? config.deformityCorrection.ruleValue === VISIBLE
                            ? 'Procedure_Data_Enabled'
                            : 'DEFORMITY_CORRECTION'
                        : checkMetadata(
                              config.deformityCorrection,
                              'Procedure_data'
                          )
                        ? 'Procedure_Data_Enabled'
                        : false
                );
                obj = data?{ ...obj, technologies: data }:obj;
            }

            if (isConfigApplicable(config.biologicsUsed)) {
                data = procedureFilterData(
                    modifiedResponse.biologicsUsed,
                    config.biologicsUsed,
                    checkMetadata(config.biologicsUsed, 'BIOLOGICS_USED')
                        ? config.biologicsUsed.ruleValue === VISIBLE
                            ? 'Procedure_Data_Enabled'
                            : 'BIOLOGICS_USED'
                        : checkMetadata(config.biologicsUsed, 'Procedure_data')
                        ? 'Procedure_Data_Enabled'
                        : false
                );
                obj =data? { ...obj, biologicsUsed: data }:obj;
            }

            if (
                config.levelsUsed === 'NOT_VISIBLE' &&
                (isEquity || procedurePageVisibility)
            ) {
                obj = data?{ ...obj, levels: ['ADDITIONAL_PROCEDURE_DATA'] }:obj;
            }

            if (isConfigApplicable(config.physicianFinderEligibility)) {
                data = procedureFilterData(
                    modifiedResponse.therapies,
                    config.physicianFinderEligibility,
                    checkMetadata(
                        config.physicianFinderEligibility,
                        'PHYSICIAN_FINDER_ELIGIBILITY'
                    )
                        ? config.physicianFinderEligibility.ruleValue ===
                          VISIBLE
                            ? 'Procedure_Data_Enabled'
                            : 'PHYSICIAN_FINDER_ELIGIBILITY'
                        : checkMetadata(
                              config.physicianFinderEligibility,
                              'Procedure_data'
                          )
                        ? 'Procedure_Data_Enabled'
                        : false,
                    'physicianFinderEligibility'
                );
                obj = data
                    ? { ...obj, therapies: data }
                    : obj ;
            }

            if (isConfigApplicable(config.biologicsDetail)) {
                data = procedureFilterData(
                    modifiedResponse.biologicsDetail,
                    config.biologicsDetail,
                    checkMetadata(config.biologicsDetail, 'BIOLOGICS')
                        ? 'Procedure_Data_Enabled'
                        : checkMetadata(
                              config.biologicsDetail,
                              'Procedure_data'
                          )
                        ? 'Procedure_Data_Enabled'
                        : false,
                    'biologicsUsed'
                );
                obj = data?{ ...obj, biologicsDetail: data }:obj;
            }

            if (isConfigApplicable(config.retractorUsed)) {
                data = procedureFilterData(
                    modifiedResponse.retractors,
                    config.retractorUsed,
                    checkMetadata(config.retractorUsed, 'RETRACTOR_USED')
                        ? config.retractorUsed.ruleValue === VISIBLE
                            ? 'Procedure_Data_Enabled'
                            : 'RETRACTOR_USED'
                        : checkMetadata(config.retractorUsed, 'Procedure_data')
                        ? 'Procedure_Data_Enabled'
                        : false,
                    'retractorUsed'
                );
                obj =data? { ...obj, retractors: data }:obj;
            }
        }

        yield put({
            type: GET_PROCEDURE_INFO_SUCCESS,
            payload:
                isFrom === 'Equity' || isFrom === 'Usage'
                    ? obj
                    : modifiedResponse,
        });

        yield put(getDropdownOptionsRequest('procedures'));
    } else {
        yield put({
            type: GET_PROCEDURE_INFO_FAILURE,
            payload: {},
        });
    }
}

function* validateReplenProductsSaga(action, salesOrg) {
    const usageDetails = yield select(
        (state) => state.reportUsageRootReducer.usageDetails
    );
    const { physicianId, isMastOrder } = yield select((state) => ({
        physicianId:
            state?.reportUsageRootReducer?.physicianDropdownValue?.physicianId,
        isMastOrder: state?.reportUsageRootReducer?.usageDetails?.isMastOrder,
    }));
    const params = {
        itemCFNs: action.payload,
        soldToAccount: usageDetails.accountId,
        PhysicianId: physicianId,
        isMastOrder: !!isMastOrder,
    };
    const response = yield validateReplenProductsFunc(params, salesOrg);
    yield put({
        type: VALIDATE_REPLEN_PRODUCTS_RESPONSE,
        payload:
            response !== 'error' && response.products ? response.products : [],
    });
}

function* validateProductDetailsSaga(action) {
    const { salesOrgs } = yield select((state) => ({
        salesOrgs: state.loginReducer.hybrisUserDetails.salesOrgs,
    }));
    const { physicianId } = yield select((state) => ({
        physicianId:
            state?.reportUsageRootReducer?.physicianDropdownValue?.physicianId,
    }));
    const { accountId, isMastOrder } = yield select((state) => ({
        accountId: state?.reportUsageRootReducer.usageDetails.accountId,
        isMastOrder: state?.reportUsageRootReducer?.usageDetails?.isMastOrder,
    }));
    action.payload.reqBody = {
        ...action.payload.reqBody,
        orderType: 'ZLB',
        salesOrg: salesOrgs?.length > 0 && salesOrgs[0],
        PhysicianId: physicianId,
        accountNo: accountId,
        isMastOrder: !!isMastOrder,
    };
    const response = yield validateProductDetailsFunc(action.payload.reqBody);
    if (response !== 'error') {
        const validatedProducts = response.products ? response.products : [];
        const validatedUnidFeeItem = validatedProducts?.[0]?.isUNiDPlanFeeItem;
        if (action.payload.isForReplen) {
            const itemTableData = yield select(
                (state) => state.reportUsageRootReducer.itemTableData
            );
            const patientDetails = yield select(
                (state) => state.reportUsageRootReducer.patientDetails
            );
            const { patientIdMandatory } = yield select(
                (state) => state.loginReducer
            );
            const myCaseResourceType = yield select(
                (state) => state.reportUsageRootReducer.myCaseResourceType
            );
            const validatedItemTableData = getValidatedItemTableData(
                itemTableData,
                validatedProducts,
                myCaseResourceType
            );
            if (
                checkIfValidProductsInRecordScreen(
                    validatedProducts,
                    validatedItemTableData,
                    patientDetails,
                    myCaseResourceType,
                    patientIdMandatory
                )
            ) {
                const replenItems =
                    validatedItemTableData &&
                    getReplenNonTissueItems(
                        myCaseResourceType === 'reportPayment'
                            ? validatedItemTableData.filter(
                                  (data) =>
                                      data.isAdditionalCartEntry ||
                                      data.isAdditionalCartChild
                              )
                            : validatedItemTableData,
                        myCaseResourceType
                    );
                if (replenItems?.length > 0) {
                    yield* validateReplenProductsSaga(
                        validateReplenProducts(
                            replenItems
                                .map((x) => x.cfn || x.productCFN)
                                .toString()
                        ),
                        replenItems[0].salesOrg
                    );
                }
            }
        }
        yield put({
            type: VALIDATE_PRODUCT_DETAILS_SUCCESS,
            payload: {
                validItems: validatedProducts,
                productsValidated: true,
            },
        });
    } else {
        yield put({
            type: VALIDATE_PRODUCT_DETAILS_FAILURE,
            payload: {
                validItems: [],
                productsValidated: false,
            },
        });
    }
}

function* validateRelenSaga(action) {
    const { salesOrgs } = yield select((state) => ({
        salesOrgs: state.loginReducer.hybrisUserDetails.salesOrgs,
    }));
    const { physicianId } = yield select((state) => ({
        physicianId:
            state?.reportShipToAddressReducer?.insideSurgeryDetails?.physicianId
                ?.physicianId,
    }));
    const physicianDisplayName = yield select(
        (state) =>
            state?.reportShipToAddressReducer?.insideSurgeryDetails?.physicianId
                ?.physicianDisplayName
    );
    const accountName = yield select(
        (state) =>
            state?.reportShipToAddressReducer?.insideSurgeryDetails?.accountId
                ?.accountName
    );
    const outsidePhysicianDisplayName = yield select(
        (state) =>
            state?.reportShipToAddressReducer?.outsideSurgeryDetails
                ?.physicianId?.physicianDisplayName
    );
    const outsideAccountName = yield select(
        (state) =>
            state?.reportShipToAddressReducer?.outsideSurgeryDetails?.accountId
                ?.accountName
    );
    const outsideTerritoryPhysicianId = yield select(
        (state) =>
            state.reportShipToAddressReducer?.outsideSurgeryDetails?.physicianId
                ?.physicianId
    );
    const outsideTerritoryAccountId = yield select(
        (state) =>
            state.reportShipToAddressReducer?.outsideSurgeryDetails?.accountId
                ?.accountId
    );
    const { accountId } = yield select((state) => ({
        accountId:
            state?.reportShipToAddressReducer?.insideSurgeryDetails?.accountId
                ?.accountId,
    }));
    const { territoryValue } = yield select((state) => ({
        territoryValue: state?.reportUsageRootReducer.territoryValue,
    }));
    // const groupData = action.payload.reduce((prev, curr) => {
    //     prev[curr.salesOrg] = prev[curr.salesOrg] || [];
    //     prev[curr.salesOrg].push(curr.cfn || curr.productCFN);
    //     return prev;
    // }, {});
    action.payload.reqBody = {
        orderType: 'ZLCR',
        salesOrg: salesOrgs?.length > 0 && salesOrgs[0],
        physicianId:
            territoryValue === WithinTerritory()
                ? physicianId
                : outsideTerritoryPhysicianId,
        accountNo:
            territoryValue === WithinTerritory()
                ? accountId
                : outsideTerritoryAccountId,
        products: action.payload.map((x) => x.cfn || x.productCFN),
        physicianName:
            territoryValue === WithinTerritory()
                ? physicianDisplayName
                : outsidePhysicianDisplayName,
        accountName:
            territoryValue === WithinTerritory()
                ? accountName
                : outsideAccountName,
    };
    const response = yield validateRelenFunc(action.payload.reqBody);
    if (response !== 'error') {
        var accountMsgs = [];
        var surgeonMsgs = [];
        var productCFN = [];
        if (response?.errors?.length > 0) {
            response?.errors?.forEach((msg) => {
                if (msg.statusCode === '11001') {
                    accountMsgs.push({
                        description: msg.statusDescription,
                        products: msg.products,
                    });
                } else if (msg.statusCode === '11000') {
                    surgeonMsgs.push({
                        description: msg.statusDescription,
                        products: msg.products,
                    });
                }
            });
            const firstSurgeonMsg = surgeonMsgs[0];
            const firstAccountMsg = accountMsgs[0];
            action.payload.reqBody.products.map((cfn) => {
                if (firstSurgeonMsg?.products.some((a) => a.includes(cfn)))
                    productCFN.push(cfn);
            });
            action.payload.reqBody.products.map((cfn) => {
                if (firstAccountMsg?.products.some((a) => a.includes(cfn)))
                    productCFN.push(cfn);
            });
        }
        yield put({
            type: VALIDATE_REPLEN_SUCCESS,
            accountError: accountMsgs,
            surgeonError: surgeonMsgs,
            productsWithError: productCFN,
            showShipToAddressPopup:
                productCFN?.length ===
                action?.payload?.reqBody?.products?.length
                    ? false
                    : true,
        });
    } else {
        yield put({
            type: VALIDATE_REPLEN_FAILURE,
            payload: {
                validItems: [],
                productsValidated: false,
            },
        });
    }
}

function* validateUnidPlanFeeItemsSaga(action) {
    const response = yield validateUnidPlanFeeItemsFunc(action.payload.reqBody);

    if (response !== 'error') {
        const validatedProducts = response.products ? response.products : [];
        const validatedUnidFeeItem = validatedProducts;
        // if (action.payload.isForReplen) {
        //     const itemTableData = yield select(
        //         (state) => state.reportUsageRootReducer.itemTableData
        //     );
        //     const patientDetails = yield select(
        //         (state) => state.reportUsageRootReducer.patientDetails
        //     );
        //     const { patientIdMandatory } = yield select(
        //         (state) => state.loginReducer
        //     );
        //     const myCaseResourceType = yield select(
        //         (state) => state.reportUsageRootReducer.myCaseResourceType
        //     );
        //     const validatedItemTableData = getValidatedItemTableData(
        //         itemTableData,
        //         validatedProducts,
        //         myCaseResourceType
        //     );
        //     console.log(
        //         checkIfValidProductsInRecordScreen(
        //             validatedProducts,
        //             validatedItemTableData,
        //             patientDetails,
        //             myCaseResourceType,
        //             patientIdMandatory
        //         ),
        //         'valid product check'
        //     );
        //     if (
        //         checkIfValidProductsInRecordScreen(
        //             validatedProducts,
        //             validatedItemTableData,
        //             patientDetails,
        //             myCaseResourceType,
        //             patientIdMandatory
        //         )
        //     ) {
        //         const replenItems =
        //             validatedItemTableData &&
        //             getReplenNonTissueItems(
        //                 myCaseResourceType === 'reportPayment'
        //                     ? validatedItemTableData.filter(
        //                           (data) =>
        //                               data.isAdditionalCartEntry ||
        //                               data.isAdditionalCartChild
        //                       )
        //                     : validatedItemTableData,
        //                 myCaseResourceType
        //             );
        //         if (replenItems?.length > 0) {
        //             yield* validateReplenProductsSaga(
        //                 validateReplenProducts(
        //                     replenItems
        //                         .map((x) => x.cfn || x.productCFN)
        //                         .toString()
        //                 ),
        //                 replenItems[0].salesOrg
        //             );
        //         }
        //     }
        // }
        yield put({
            type: VALIDATE_UNID_PLAN_FEE_ITEMS_SUCCESS,
            payload: {
                validItems: validatedUnidFeeItem,
                productsValidated: true,
            },
        });
    } else {
        yield put({
            type: VALIDATE_UNID_PLAN_FEE_ITEMS_FAILURE,
            payload: {
                validItems: [],
                productsValidated: false,
            },
        });
    }
}

const getAttachmentPromise = (attachmentObj, myCaseRef, salesOrg) => {
    const formData = new FormData();
    formData.append('poUploadedFile', attachmentObj, attachmentObj.name);
    formData.append('myCaseRef', myCaseRef);
    formData.append('salesOrg', salesOrg);
    return usageAttachmentUploadFunc(formData);
};

function* usageAttachmentUploadSaga(action) {
    const { existingTissueImages, existingNonTissueImages } = yield select(
        (state) => ({
            existingTissueImages:
                state.reportUsageRootReducer?.poTissueImageDetails,
            existingNonTissueImages:
                state.reportUsageRootReducer?.poNonTissueImageDetails,
        })
    );
    try {
        const promiseArray = [];
        const { files, tissue, nonTissue, myCaseRef } = action.payload;
        [...(files || [])].forEach((file) => {
            if (tissue && nonTissue) {
                promiseArray.push(
                    getAttachmentPromise(file, myCaseRef, 'S030'),
                    getAttachmentPromise(file, myCaseRef, 'S002')
                );
            } else if (tissue) {
                promiseArray.push(
                    getAttachmentPromise(file, myCaseRef, 'S030')
                );
            } else {
                promiseArray.push(
                    getAttachmentPromise(file, myCaseRef, 'S002')
                );
            }
        });

        const responses = yield Promise.all(promiseArray);
        const tissueFiles = [];
        const nonTissueFiles = [];
        responses.forEach((response) => {
            if (response?.fileName?.includes('_S030_')) {
                tissueFiles.push(response.fileName);
            } else if (response?.fileName?.includes('_S002_')) {
                nonTissueFiles.push(response.fileName);
            }
        });

        if (nonTissueFiles.length > 0) {
            yield put(
                setPONonTissueImageDetails(
                    existingNonTissueImages
                        ? `${existingNonTissueImages},${nonTissueFiles.join()}`
                        : nonTissueFiles.join()
                )
            );
            // yield put({
            //     type: USAGE_ATTACHMENT_UPLOAD_SUCCESS_NONTISSUE,
            //     payload: existingNonTissueImages
            //         ? `${existingNonTissueImages},${nonTissueFiles.join()}`
            //         : nonTissueFiles.join(),
            // });
        }

        if (tissueFiles.length > 0) {
            yield put(
                setPOTissueImageDetails(
                    existingTissueImages
                        ? `${existingTissueImages},${tissueFiles.join()}`
                        : tissueFiles.join()
                )
            );
            // yield put({
            //     type: USAGE_ATTACHMENT_UPLOAD_SUCCESS_TISSUE,
            //     payload: existingTissueImages
            //         ? `${existingTissueImages},${tissueFiles.join()}`
            //         : tissueFiles.join(),
            // });
        }
    } catch (e) {
        logUiErrorToBackend(e);
        yield put({
            type: USAGE_ATTACHMENT_UPLOAD_FAILURE,
            payload: {},
        });
    }
}

function* deleteAttachmentSaga(action) {
    const { existingTissueImages, existingNonTissueImages } = yield select(
        (state) => ({
            existingTissueImages:
                state.reportUsageRootReducer?.poTissueImageDetails?.split(','),
            existingNonTissueImages:
                state.reportUsageRootReducer?.poNonTissueImageDetails?.split(
                    ','
                ),
        })
    );
    try {
        const response = yield deleteAttachmentFunc(action.payload);
        if (response.status) {
            const { fileName, isTissue } = action.payload;

            if (isTissue) {
                const deletedImageIndex = existingTissueImages.findIndex(
                    (extImg) => extImg === fileName
                );
                existingTissueImages.splice(deletedImageIndex, 1);
            } else {
                const deletedImageIndex = existingNonTissueImages.findIndex(
                    (exntImg) => exntImg === fileName
                );
                existingNonTissueImages.splice(deletedImageIndex, 1);
            }
            yield put({
                type: DELETE_ATTACHMENT_REQUEST_SUCCESS,
                payload: {
                    isTissue,
                    imagesToBeUpdated: isTissue
                        ? existingTissueImages.join()
                        : existingNonTissueImages.join(),
                },
            });
        }
    } catch (e) {
        yield put({
            type: DELETE_ATTACHMENT_REQUEST_FAILURE,
            payload: {},
        });
    }
}
function* getImagePoPreviewSaga(action) {
    try {
        const response = yield getImagePoPreviewFunc(action.payload);
        if (response.status) {
            yield put({
                type: GET_IMAGE_PO_PREVIEW_SUCCESS,
                payload: response.data.attachment,
            });
        }
    } catch (e) {
        yield put({
            type: GET_IMAGE_PO_PREVIEW_FAILURE,
            payload: {},
        });
    }
}

function* cancelUsageOrderSaga(action) {
    const response = yield cancelUsageOrderFunc(action.payload);
    if (
        action.payload.isCancelWithoutReason &&
        response &&
        response.statusCode === '200'
    ) {
        if (response.message === 'CC') {
            yield put({
                type: SET_SHOW_CONTACT_LOGISTICS_POPUP,
                payload: true,
            });
        }
    }
    yield put({
        type: CANCEL_USAGE_ORDER_COMPLETION,
        payload: response,
    });
}

function* fetchDiscreparencySaga(action) {
    const response = yield getDisparencyFunc(
        convertObjectToQueryParams(action.payload)
    );
    if (response !== 'error') {
        yield put({
            type: GET_DISCREPANCY_DATA_SUCCESS,
            payload: response.discrepancyDto,
        });
    } else {
        yield put({
            type: GET_DISCREPANCY_DATA_FAILURE,
            payload: { status: 'failed' },
        });
    }
}

const getDiscrepancyAttachmentPromise = (attachmentObj, myCaseRef) => {
    const formData = new FormData();
    formData.append('poUploadedfile ', attachmentObj, attachmentObj.name);
    formData.append('myCaseRef', myCaseRef);
    return discrepancyAttachmentUploadFunc(formData);
};

function* usageDiscrepancyAttachmentUploadSaga(action) {
    const { existingImages } = yield select((state) => ({
        existingImages: state.reportUsageRootReducer?.discrepancyAttachment,
    }));

    try {
        const promiseDescipancyArray = [];
        const { files, myCaseRef } = action.payload;
        const discrepancyFiles = [];
        for (let i = 0; i < files.length; i++) {
            promiseDescipancyArray.push(
                getDiscrepancyAttachmentPromise(files[i], myCaseRef)
            );
        }
        const responses = yield Promise.all(promiseDescipancyArray);
        if (existingImages?.length > 0) {
            discrepancyFiles.push(...existingImages);
        }
        responses.forEach((response) => {
            if (response?.fileName) {
                discrepancyFiles.push(response.fileName);
            }
        });
        yield put({
            type: USAGE_DISCREPANCY_ATTACHMENT_UPLOAD_SUCCESS,
            payload: discrepancyFiles,
        });
    } catch (e) {
        yield put({
            type: USAGE_DISCREPANCY_ATTACHMENT_UPLOAD_FAILURE,
            payload: {},
        });
    }
}

function* discrepancyDeleteAttachmentSaga(action) {
    const { existingImages } = yield select((state) => ({
        existingImages: state.reportUsageRootReducer?.discrepancyAttachment,
    }));

    try {
        const response = yield discrepancyDeleteAttachmentFunc(action.payload);
        if (response.status) {
            const { fileName } = action.payload;
            const deletedImageIndex = existingImages.findIndex(
                (extImg) => extImg === fileName
            );
            existingImages.splice(deletedImageIndex, 1);
            yield put({
                type: DELETE_DISCREPANCY_ATTACHMENT_REQUEST_SUCCESS,
                payload: {
                    existingImages: existingImages,
                },
            });
        }
    } catch (e) {
        yield put({
            type: DELETE_DISCREPANCY_ATTACHMENT_REQUEST_FAILURE,
            payload: {},
        });
    }
}
function* discrepancyUpdateDataSaga(action) {
    try {
        const attachedFilesReset = action.payload?.discrepancyChanged;
        const response = yield discrepancyUpdateDataFunc(action.payload);
        if (response?.statusCode) {
            yield put({
                type: PUT_DISCREPANCY_DATA_REQUEST_SUCCESS,
                payload: response,
            });
            if (attachedFilesReset) {
                yield put(resetDescrepancyDetails());
            }
        } else {
            yield put({
                type: PUT_DISCREPANCY_DATA_REQUEST_FAILURE,
                payload: {},
            });
        }
    } catch (e) {
        yield put({
            type: PUT_DISCREPANCY_DATA_REQUEST_FAILURE,
            payload: {},
        });
    }
}

function* getOrderStatusDetails(action) {
    const myCaseRef = action.payload;
    const response = yield getOrderStatusDetailsFunc(myCaseRef);
    if (response !== 'error') {
        yield put({
            type: GET_ORDER_STATUS_DETAILS_SUCCESS,
            payload: response,
        });
    } else {
        yield put({
            type: GET_ORDER_STATUS_DETAILS_FAILURE,
            payload: { status: '' },
        });
    }
}

function* getAccountValidationMessage(action) {
    const queryParam = action.payload;
    try {
        const response = yield getAccountMessageValidationFunc(queryParam);
        if (response !== 'error') {
            yield put({
                type: VALIDATE_ACCOUNT_SUCCESS,
                data: response,
                statusCode: response.statusCode,
                statusMessage: response.statusMessage,
                // loadAll: value?.isLoadAll,
            });
        }
    } catch (e) {
        logUiErrorToBackend(e);
        yield put({
            type: VALIDATE_ACCOUNT_FAILURE,
            statusCode: errorHandler('503'),
            statusMessage: e?.Error,
        });
    }
}

// function* getBarcodeItemDetails(action) {
//     const response = yield getDropdownOptionsFunc(action.payload);
//     if (response !== 'error') {
//         yield put({
//             type: GET_DROPDOWN_OPTIONS_SUCCESS,
//             payload: {
//                 dropdownName: action.payload.dropdownType,
//                 dropdownOptions: response,
//             },
//         });
//     } else {
//         yield put({
//             type: GET_DROPDOWN_OPTIONS_FAILURE,
//             payload: {
//                 dropdownName: action.payload.dropdownType,
//                 dropdownOptions: [],
//             },
//         });
//     }
// }

function* usageDetailsRootSaga() {
    yield all([
        // takeEvery(GET_BARCODE_ITEMS,getBarcodeItemDetailSaga),
        takeLatest(VALIDATE_REPORT_ACCOUNT, getAccountValidationMessage),
        takeLatest(GET_USAGE_DETAILS, fetchUsageDetailsSaga),
        takeLatest(CREATE_USAGE_ORDER, createUsageOrderSaga),
        takeLatest(UPDATE_USAGE_ORDER, updateUsageOrderSaga),
        takeLatest(GET_PRICES_FOR_ITEMS, getPricesForItemsSaga),
        takeEvery(GET_DROPDOWN_OPTIONS, getDropdownOptionsSaga),
        takeLatest(VALIDATE_MAZOR_CODE, validateMazorCodeSaga),
        takeLatest(GET_PROCEDURE_INFO, getProcedureInfoSaga),
        takeLatest(VALIDATE_REPLEN, validateRelenSaga),
        takeLatest(VALIDATE_PRODUCT_DETAILS, validateProductDetailsSaga),
        takeLatest(VALIDATE_UNID_PLAN_FEE_ITEMS, validateUnidPlanFeeItemsSaga),
        takeLatest(VALIDATE_REPLEN_PRODUCTS, validateReplenProductsSaga),
        takeEvery(USAGE_ATTACHMENT_UPLOAD, usageAttachmentUploadSaga),
        takeEvery(DELETE_ATTACHMENT_REQUEST, deleteAttachmentSaga),
        takeLatest(GET_IMAGE_PO_PREVIEW, getImagePoPreviewSaga),
        takeLatest(CANCEL_USAGE_ORDER, cancelUsageOrderSaga),
        takeLatest(GET_SHIP_TO_ADDRESS_REPORT_USAGE, shipToAddressSaga),
        takeLatest(GET_SHIPPING_METHODS_REPORT_USAGE, shippingMethodSaga),
        takeLatest(GET_DISCREPANCY_DATA, fetchDiscreparencySaga),
        takeLatest(
            USAGE_DISCREPANCY_ATTACHMENT_UPLOAD,
            usageDiscrepancyAttachmentUploadSaga
        ),
        takeLatest(
            DELETE_DISCREPANCY_ATTACHMENT_REQUEST,
            discrepancyDeleteAttachmentSaga
        ),
        takeLatest(PUT_DISCREPANCY_DATA_REQUEST, discrepancyUpdateDataSaga),
        takeLatest(GET_ORDER_STATUS_DETAILS, getOrderStatusDetails),
        takeEvery(GET_TRANSFER_RECIPIENT_METHODS, getTransferRecipient),
    ]);
}

export default usageDetailsRootSaga;
